// src/platform/handoff.ts: whether this page load is a hand-off into setup (the sign-up confirm's link, or the link after a quote is
// accepted: /auth/continue?via=setup, worker auth/tokens.ts#linkFor). Read once, when the app starts, before the link is used and the
// address changes. While it is, the waits between the navy pages wear the same frame (HandoffWait) instead of a white page.
import { Shell } from "./Shell";
import { QuietSpinner } from "../ui/Feedback";

export const setupHandoff: boolean =
  typeof window !== "undefined" && window.location.pathname === "/auth/continue" && /(?:^\?|&)via=setup(?:&|$)/.test(window.location.search);

/** Where Sign Out on setup's frame goes: the team's sign-in page ("Team workspace", "Sign In"), not the families' "Welcome Back". */
export const TEAM_SIGNIN = "/signin?next=%2Fteam";

/** The wait on the way into setup: the navy side and nothing else yet (the spinner shows only if it takes a while). */
export function HandoffWait() {
  return (
    <Shell screen="handoff" mid>
      <div class="qt-s-body">
        <QuietSpinner label="Opening your setup" />
      </div>
    </Shell>
  );
}
